import React, { Component } from "react"
import { Subject, Subscription, of, concat } from "rxjs"
import { catchError, debounceTime, filter, map, switchMap } from "rxjs/operators"
import { AsyncTypeahead, InputProps } from "react-bootstrap-typeahead"
import LocationQueryGetObservable from "../../api/Location/LocationQueryGet"
import Address from "../../api/Location/LocationModel/Address"

export interface AddressInputProps {
  id?: string
  emptyLabel?: string
  promptText?: string
  minLength?: number
  placeholder?: string
  selected?: Address
  inputProps?: InputProps
  isInvalid?: boolean
  disabled?: boolean,
  disableSuggestions?: boolean,
  onAddressChange: (address: Address | string | undefined) => void
}

interface AddressInputState {
  options: Address[],
  isOptionsLoading: boolean
}

export default class AddressInput extends Component<AddressInputProps, AddressInputState> {
  state: AddressInputState = {
    options: [],
    isOptionsLoading: false
  }
  addressesQuery$?: Subject<string>
  addressesSubscription?: Subscription

  componentDidMount() {
    this.addressesQuery$ = new Subject<string>()
    this.addressesSubscription = this.addressesQuery$.pipe(
      debounceTime(500),
      filter(query => (query ?? "").trim().length >= (this.props.minLength || AddressInput.defaultProps.minLength)),
      switchMap((query) => concat(
        of({ isOptionsLoading: true }),
        LocationQueryGetObservable(query).pipe(
          map((options) => ({ isOptionsLoading: false, options: options })),
          catchError(() =>
            of({ isOptionsLoading: false })
          )
        )
      ))
    ).subscribe(
      (state: { isOptionsLoading: boolean, options?: Address[] }) => {
        state.options ?
          this.setState({ isOptionsLoading: state.isOptionsLoading, options: state.options }) :
          this.setState({ isOptionsLoading: state.isOptionsLoading })
      },
      () => this.setState({ isOptionsLoading: false })
    )
  }

  componentWillUnmount() {
    this.addressesSubscription && this.addressesSubscription.unsubscribe()
  }

  handleSearch = (query: string) => !this.props.disableSuggestions && this.addressesQuery$ && this.addressesQuery$.next(query)

  render() {
    return (
      <AsyncTypeahead
        id={this.props.id}
        labelKey={option => option.Text || ""}
        emptyLabel={this.props.emptyLabel}
        minLength={0}
        placeholder={this.props.placeholder}
        promptText={this.props.promptText}
        isLoading={this.state.isOptionsLoading}
        onSearch={this.handleSearch}
        open={!!this.props.disableSuggestions ? false : undefined}
        options={this.state.options}
        filterBy={() => true}
        inputProps={this.props.inputProps}
        isInvalid={this.props.isInvalid}
        disabled={this.props.disabled}
        onChange={selected => { if (selected[0]) {this.props.onAddressChange(selected[0])}}}
        onInputChange={(input) => this.props.onAddressChange(input)}
        selected={this.props.selected ? [this.props.selected] : undefined} />
    )
  }

  static defaultProps = {
    id: "addressSearch",
    emptyLabel: "No Result Found",
    minLength: 3,
    disableSuggestions: true
  }
}
